var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoErrorInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rect\\xE1ngulo_44796",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23427",
    "data-name": "Grupo 23427",
    transform: "translate(-480 -976)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 480, 976)",
    filter: "url(#Rect\\xE1ngulo_44796)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_44796-2",
    "data-name": "Rect\\xE1ngulo 44796",
    width: 20,
    height: 20,
    rx: 10,
    transform: "translate(9 6)",
    fill: "#ed3b6b",
    opacity: 0.099
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_66304",
    "data-name": "Trazado 66304",
    d: "M227.531,203.7a1.069,1.069,0,0,1-1.512,0l-2.268-2.268-2.268,2.268a1.069,1.069,0,0,1-1.512-1.512l2.268-2.269-2.268-2.268a1.069,1.069,0,0,1,1.512-1.512l2.268,2.268,2.268-2.268a1.069,1.069,0,1,1,1.512,1.512l-2.268,2.268,2.268,2.269A1.069,1.069,0,0,1,227.531,203.7Z",
    transform: "translate(275.248 792.076)",
    fill: "#ed3b6b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoErrorInput);
export default __webpack_public_path__ + "static/media/IconoErrorInput.53d0337c3548303a9755bef0bd087757.svg";
export { ForwardRef as ReactComponent };